import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './ProductColumn.module.scss'

function ProductColumn({ value }: { value: string }) {
  const { organisation } = useUserInfoStore((state) => state)

  return (
    <>
      {Object.keys(organisation).length && !organisation.isLegal ? (
        <span
          className={
            Object.keys(organisation).length && !organisation.isLegal
              ? cn.blured
              : ''
          }
        >
          ******
        </span>
      ) : (
        <span>{value}</span>
      )}
    </>
  )
}

export default ProductColumn
